import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Directive({
	selector: '[hasPermission]'
})

export class HasPermissionDirective implements OnInit {

	@Input() hasPermission: string;

	constructor(
		private el: ElementRef,
		private authenticationService: AuthenticationService
	) {
		this.showElement(false);
	}

	ngOnInit() {
		this.authenticationService.hasPermission(this.hasPermission).subscribe((res: boolean) => {
			this.showElement(res);
		});
	}

	private showElement(show: boolean) {
		if (!this.el) {
			return;
		}
		this.el.nativeElement.style.display = show ? null : 'none';
	}
}
